<template>
  <v-container>
    <markdown :source="readme" />
  </v-container>
</template>

<script>
import Readme from '@/../README.md';
import Markdown from '@/components/Markdown';

export default {
  name: 'Home',
  components: {Markdown},
  computed: {
    readme() {
      return Readme;
    },
  },
};
</script>
